export default __webpack_public_path__ + "static/media/am6.29b05d66.jpg";